<template>
    <myScroll class="scroll ">
        <div class="mypoplearnerwrap">
            <div class="profile">
                <div class="face">
                    <div class="faceimg" v-if="me.id>0">
                        <ffupload v-if="isadmin" :fileurl="me.face" @update:fileurl="updateface" :updata="{'mediatype':'avatar2'}"></ffupload>
                        <img v-else :src="me.face" />

                    </div>
                </div>
                <div class="info">
                    <div v-if="!me.x_isedit" class="view">
                        <dl><dt>{{$common.dicword('username',true)}}</dt><dd>{{me.username}}</dd></dl>
                        <dl><dt>{{$common.dicword('mobile',true)}}</dt><dd>{{me.mobile}}</dd></dl>
                        <dl v-if="!$common.basic.chempty(me.schooltitle)"><dt>{{$common.dicword('school',true)}}</dt><dd>{{me.schooltitle}}</dd></dl>
                        <dl v-if="!$common.basic.chempty(me.classtitle)"><dt>{{$common.dicword('infoclass',true)}}</dt><dd>{{me.classtitle}}</dd></dl>
                        <dl v-if="isteacher"><dt>{{$common.dicword('admin',true)}}</dt><dd>{{$common.chint2bool(me.isadmin)}}</dd></dl>
                        <dl><dt>{{$common.dicword('realname',true)}}</dt><dd v-html="me.realname"></dd></dl>
                        <dl><dt>{{$common.dicword('nickname',true)}}</dt><dd>{{me.showname}}</dd></dl>
                        <dl><dt>{{$common.dicword('birth',true)}}</dt><dd>{{$common.basic.dateformat( me.birth)}}</dd></dl>
                        <dl><dt>{{$common.dicword('gender',true)}}</dt><dd>{{$common.chgender(me.sex)}}</dd></dl>
                        <dl><dt>{{$common.dicword('address',true)}}</dt><dd>{{me.addr}}</dd></dl>
                        <dl><dt>{{$common.dicword('disabled',true)}}</dt><dd>{{$common.chint2bool(me.ischeck?0:1)}}</dd></dl>
                        <dl v-if="isadmin"><dt>&nbsp;</dt><dd><a href="#" class="btn1" @click="me.x_isedit=true">{{$common.dicword('modifyprofile')}}</a></dd></dl>
                    </div>
                    <div v-else class="edit">
                        <dl v-if="me.id==0"><dt><span>*</span>{{$common.dicword('username',true)}}</dt><dd><el-input :class="{iserr:iserrusername}" @focus="iserrusername=false" @change="iserrusername=!me.username" v-model="me.username" maxlength="50"></el-input></dd></dl>
                        <dl><dt><span>*</span>{{$common.dicword('realname',true)}}</dt><dd><el-input :class="{iserr:iserrrealname}" @focus="iserrrealname=false" @change="iserrrealname=!me.realname" v-model="me.realname" maxlength="50"></el-input></dd></dl>
                        <dl><dt>{{$common.dicword('nickname',true)}}</dt><dd><el-input v-model="me.showname" maxlength="50"></el-input></dd></dl>
                        <dl v-if="isteacher">
                            <dt>{{$common.dicword('admin',true)}}</dt>
                            <dd>
                                <el-switch v-model="me.isadmin" :active-value="1" :inactive-value="0"></el-switch>
                            </dd>
                        </dl>
                        <dl v-else>
                            <dt>{{$common.dicword('infoclass',true)}}</dt>
                            <dd>
                                <el-select v-model="me.groupid">
                                    <el-option v-for="item in grouplist" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                                </el-select>
                            </dd>
                        </dl>
                        <dl><dt>{{$common.dicword('pwd',true)}}</dt><dd><el-input v-model="me.pwd" maxlength="50"></el-input></dd></dl>
                        <dl><dt>{{$common.dicword('mobile',true)}}</dt><dd><el-input v-model="me.mobile" maxlength="50"></el-input></dd></dl>

                        <dl><dt>{{$common.dicword('birth',true)}}</dt><dd><el-date-picker type="date" v-model="me.birth" value-format="yyyy-MM-dd" maxlength="50"></el-date-picker></dd></dl>
                        <dl>
                            <dt>{{$common.dicword('gender',true)}}</dt>
                            <dd>
                                <el-radio-group v-model="me.sex">
                                    <el-radio-button :label="1">{{$common.dicword('male')}}</el-radio-button>
                                    <el-radio-button :label="2">{{$common.dicword('female')}}</el-radio-button>
                                </el-radio-group>
                            </dd>
                        </dl>
                        <dl><dt>{{$common.dicword('address',true)}}</dt><dd><el-input v-model="me.addr" maxlength="100"></el-input></dd></dl>
                        <dl>
                            <dt>{{$common.dicword('disabled',true)}}</dt>
                            <dd>
                                <el-switch v-model="me.ischeck" :active-value="0" :inactive-value="1"></el-switch>
                            </dd>
                        </dl>
                        <dl><dt>&nbsp;</dt><dd class="btns"><a href="#" class="btn1" @click="saveprofile">{{$common.dicword('save')}}</a><a href="#" v-if="me.id>0" class="btncancel" @click="me.x_isedit=false">{{$common.dicword('cancel')}}</a></dd></dl>
                    </div>
                </div>
            </div>

        </div>

    </myScroll>

</template>


<script>
    export default {
        name: 'fflearnerdetail',
        data() {
            return {
                me: {},
                isadmin: false,
                grouplist: [],
                iserrusername: false,
                iserrrealname: false
            }
        },
        props: {
            memid: {
                type: Number,
                default: 0
            },
            groupid: {
                type: Number,
                default: 0
            },
            schoolid: {
                type: Number,
                default: 0
            },
            isteacher: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            saveprofile: function () {
                this.iserrrealname = !this.me.realname;
                this.iserrusername = !this.me.username;

                if (!this.iserrrealname && !this.iserrusername) {
                    let updata = { 'lev': this.isteacher ? 2 : 1, 'realname': this.me.realname, 'showname': this.me.showname, 'mobile': this.me.mobile, 'sex': this.me.sex, 'birth': this.me.birth, 'addr': this.address, 'pwd': this.me.pwd, 'ischeck': this.me.ischeck };
                    if (updata.lev == 1) {
                        updata.groupid = this.me.groupid;
                    }
                    else {
                        updata.isadmin = this.me.isadmin;
                    }
                    if (this.me.id == 0) {
                        updata.username = this.me.username;
                    }
                    let jsondata = { 'postdata': { 'api': 'member', 'act': 'mprofilesave', 'id': this.me.id, 'pid': this.me.companyid || this.schoolid, 'data': updata } };
                    this.$common.post(jsondata, (res) => {
                        this.me.x_isedit = false;
                        this.getdata(res.mid);
                        this.$emit('aftersave');
                    });
                }

            },
            updateface: function (v) {
                this.me.face = v;
                let jsondata = {
                    'postdata': { 'api': 'member', 'act': 'mfacesave', 'id': this.me.id, 'data': { 'face': v } }
                };
                this.$common.post(jsondata, () => {

                });
            },
            getdata: function (id) {
                let jsondata = { 'postdata': { 'api': 'member', 'act': 'mprofile', 'id': id } };
                this.$common.post(jsondata, res => {
                    res.infodata.schooltitle = this.$common.basic.mydecode(res.schooltitle);
                    res.infodata.classtitle = this.$common.basic.mydecode(res.classtitle);
                    res.infodata.x_isedit = res.infodata.id ? false : true;
                    if (!res.infodata.id) {
                        res.infodata.id = 0;
                        res.infodata.sex = 1;
                        res.infodata.birth = new Date();
                        res.infodata.groupid = this.groupid;
                        res.infodata.ischeck = 1;
                    }
                    else {
                        res.infodata.realname = this.$common.basic.strunformat(res.infodata.realname);
                        res.infodata.showname = this.$common.basic.strunformat(res.infodata.showname);
                    }
                    res.infodata.birth = this.$common.basic.dateformat(res.infodata.birth);
                    res.infodata.groupid = res.infodata.groupid > 0 ? res.infodata.groupid : '';

                    this.me = res.infodata || {};

                    this.grouplist = res.infodatagroup;
                    this.isadmin = res.isadmin == 1;
                });
            }

        },
        mounted() {
            this.getdata(this.memid);
        }
    }
</script>
